module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/banner@2x-188f2921069ae08ad057e7ac1646d39a.png";